import { render, staticRenderFns } from "./PlotTreeMapping.vue?vue&type=template&id=51371c84&scoped=true"
import script from "./PlotTreeMapping.vue?vue&type=script&lang=js"
export * from "./PlotTreeMapping.vue?vue&type=script&lang=js"
import style0 from "./PlotTreeMapping.vue?vue&type=style&index=0&id=51371c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51371c84",
  null
  
)

export default component.exports